import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import OfferEmbedPanel from '@/components/pages/live/attendee/OfferEmbedPanel';
import type { OfferTemplateContent } from '@/features/webinar/types';
import type { WorkspaceVisualIdentity } from '@/features/workspace/types';
import { buildOfferEmbedPreview } from '@/lib/offerEmbed';

interface OfferEmbedPreviewDialogProps {
  // Contenu renvoyé par le back (test-embed) : null tant qu'aucun aperçu n'est ouvert.
  content: OfferTemplateContent | null;
  templateId?: number;
  visualIdentity: WorkspaceVisualIdentity | null | undefined;
  onClose: () => void;
}

export default function OfferEmbedPreviewDialog({
  content,
  templateId,
  visualIdentity,
  onClose,
}: OfferEmbedPreviewDialogProps) {
  const { t } = useTranslation('createWebinar');
  return (
    <Dialog open={content !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent hideCloseButton className="max-w-md w-full p-0 overflow-hidden">
        <DialogTitle className="sr-only">
          {t('offersForm.content.testEmbedPreviewTitle')}
        </DialogTitle>
        <DialogDescription className="sr-only">
          {t('offersForm.content.testEmbedPreviewDescription')}
        </DialogDescription>
        {content && (
          <div
            className="h-[min(720px,80dvh)] flex flex-col"
            style={{ backgroundColor: visualIdentity?.backgroundColor ?? '#FFFFFF' }}
          >
            <OfferEmbedPanel
              offer={buildOfferEmbedPreview(templateId ?? 0, content)}
              visualIdentity={visualIdentity}
              onClose={onClose}
              className="flex-1"
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
